import {
  FoodSet,
  UnavailableError,
  emptyOrderMenuSet,
  types as rs,
} from 'earn-ts';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoSearch } from 'react-icons/go';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import Card from 'src/components/Order/Card';
import FoodImage from 'src/components/Order/FoodImage';
import Footer from 'src/components/Order/FooterComponent';
import Header from 'src/components/Order/HeaderComponent';
import Tab from 'src/components/Order/Tab';
import TextField from 'src/components/Order/TextField';
import { useIsAvailable } from 'src/hook/useIsAvailable';
import { addIdCategory, openFoodSet } from 'src/reducer/order/orderReducer';

/* Screen which lists sets in a category */
export default function ListMenuSet() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { categories, listMenuSets, idCategory, shopId, titleHeader, menuDef } =
    useAppSelector(state => state.order);

  const isAvailable = useIsAvailable();
  const { language } = useTranslation(['main']).i18n;
  const sets = useMemo(() => {
    return (
      (menuDef &&
        listMenuSets[idCategory]
          .map((set): [FoodSet, UnavailableError] => [
            set,
            isAvailable(undefined, set),
          ])
          .filter(([_, stat]) => [null, 'sold_out'].includes(stat))) ??
      []
    );
  }, [menuDef, listMenuSets, idCategory, isAvailable]);
  const [searchText, setSearchText] = useState('');
  const [visibleField, setVisibleField] = useState(false);

  const filteredCategories = useMemo(
    () => (categories ?? []).filter(it => isAvailable(it) == null),
    [categories, isAvailable],
  );

  const handleBack = () => {
    navigate(`/order/${shopId}/index`);
  };

  const handleChangeTab = (item: string) => {
    dispatch(addIdCategory(item));
  };

  const getFoodBySet = async (foodSet: FoodSet) => {
    const item = await foodSet.menu();
    let draft: rs.OrderMenuSet = {
      ...emptyOrderMenuSet,
      menuset_id: foodSet?.menuId,
      quantity: 1,
      sections:
        foodSet.secId != null
          ? { [foodSet.secId]: [{ food_id: foodSet.value!, options: {} }] }
          : {},
    };
    dispatch(openFoodSet({ selectedSet: item, draftSet: draft, foodSet }));
    navigate(`/order/${shopId}/listFoodSet`);
  };

  return (
    <div>
      <div className="top-0 z-20 left-0 fixed px-[15px] pt-[5px] pb-[0.5px] w-full scroll-smooth font-medium shadow-md bg-white">
        <Header
          title={titleHeader}
          isShowBack={true}
          onPressBack={handleBack}
          isShowMenu={true}
          isHideScroll={true}
          setVisibleField={setVisibleField}
          hideOnScrollOffset={90}
        />
        {visibleField && (
          <div className="relative w-full pb-[10px]">
            <GoSearch
              fontSize={16}
              className="absolute top-[8px] left-[10px]"
            />
            <TextField
              className="py-[7px] px-[38px] bg-shadow-1 rounded-[12px] text-[12px] font-normal w-full focus:ring-0 focus:outline-none"
              placeholder="Search name"
              onChange={e => setSearchText(e.target.value.toLocaleLowerCase())}
            />
          </div>
        )}
        <Tab
          listTab={filteredCategories}
          currentCategory={idCategory}
          handleChangeTab={handleChangeTab}
          lang={language}
        />
      </div>
      <div className="w-full mt-[152px]">
        {/*<div className="font-medium text-[17px] px-[15px] mb-[20px]">{pickName(categories.find(item => item?.id === idCategory)!, language)}</div>*/}
        {sets
          .filter(
            ([it, _]) => it.caption?.toLocaleLowerCase()?.includes(searchText),
          )
          .map(([set, stat], key) => (
            <div key={key} className="px-[15px]">
              {/*<div className="font-medium text-[17px] ml-2 mb-1">{key}</div>*/}
              <Card onClick={() => getFoodBySet(set)} key={key}>
                <div className="flex flex-row-reverse justify-between h-28 w-full mb-3">
                  {stat == null ? (
                    <FoodImage
                      key={set.menuId}
                      food={{ kind: 'set', def: set }}
                      className="h-full aspect-square object-cover"
                    />
                  ) : (
                    <span>SOLD OUT</span>
                  )}
                  <div className="flex flex-col flex-grow items-start justify-between">
                    <p className="font-medium text-[16px] text-left px-2 mt-2">
                      {set.caption}
                    </p>
                    <p className="font-medium text-[14px] text-left px-2">
                      {''}
                    </p>
                    <p className="font-medium text-[14px] text-left px-2">
                      {''}
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          ))}
      </div>
      {/*TotalQuantity(dataSelectedMenus) > 0 && (*/}
      <Footer />
      {/*})*/}
    </div>
  );
}
